import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'COTAS_INDEX',
    CHANGE: 'COTAS_CHANGE',
    SUCCESS: 'COTAS_SUCCESS',
    ERROR: 'COTAS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

// SEARCH

export const search = (action_id, number, reserved) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('cotas/search', {
        action_id: action_id,
        number: number,
        reserved: reserved
    })
        .then(res => {
            dispatch(changeLoading({ open: false }))

            dispatch(indexResponse({result: res.data}))
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
            }
        })
}